var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 5.75C19.6314 5.75361 19.8533 5.85956 20.0117 6.03613C20.1692 6.2119 20.253 6.44434 20.25 6.68164C20.2473 6.88943 20.1779 7.09181 20.0518 7.25391L19.9941 7.32129L9.84375 17.9854L9.84277 17.9863C9.68241 18.1538 9.46388 18.2499 9.23242 18.249H9.23145L9.23047 18.25V18.249C8.99913 18.2497 8.78039 18.1537 8.62012 17.9863V17.9854L4.00586 13.1338V13.1328C3.92536 13.048 3.86184 12.9481 3.81836 12.8389C3.77486 12.7295 3.75156 12.6121 3.75 12.4941C3.74847 12.3761 3.76799 12.2581 3.80859 12.1475C3.84918 12.037 3.91006 11.9349 3.98828 11.8477C4.06664 11.7603 4.16164 11.6891 4.26758 11.6396C4.37355 11.5902 4.48867 11.5643 4.60547 11.5625C4.72225 11.5607 4.83796 11.5836 4.94531 11.6299C5.05249 11.6761 5.14884 11.7442 5.22949 11.8291L9.23145 16.0371L18.7705 6.0166C18.9338 5.84489 19.1579 5.74645 19.3945 5.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAudio);
export default __webpack_public_path__ + "static/media/select_audio.f7dc11b047d807c2ab41fc6ecdbf1f7a.svg";
export { ForwardRef as ReactComponent };